(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire637e"];
var parcelRegister = parcelRequire.register;
parcelRegister("d1Us2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97c728619a95baa6$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");
var $97c728619a95baa6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function FilterDropdown(param) {
        var el = param.el;
        (0, $J7ygF._)(this, FilterDropdown);
        this.el = el;
        this.clicker = this.el.querySelector(".clicker");
        this.filterValues = this.el.querySelector(".filter-values");
        this.filterValuesInner = this.el.querySelector(".filter-values-inner");
        this.icon = this.clicker.querySelector(".icon");
        // get other filter dropdowns
        this.otherFilterDropdowns = document.querySelectorAll(".filter-dropdown");
        this.init();
    }
    (0, $hvJJn._)(FilterDropdown, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.clicker.addEventListener("click", function(e) {
                    e.preventDefault();
                    if (_this.el.classList.contains("active")) {
                        _this.el.classList.remove("active");
                        _this.filterValues.style.height = "0px";
                        if (_this.icon) _this.icon.innerHTML = "+";
                    } else {
                        // remove active class from other filter dropdowns
                        _this.otherFilterDropdowns.forEach(function(dropdown) {
                            dropdown.classList.remove("active");
                            // set height to 0
                            dropdown.querySelector(".filter-values").style.height = "0px";
                            // set icon to +
                            dropdown.querySelector(".icon").innerHTML = "+";
                        });
                        _this.el.classList.add("active");
                        if (_this.icon) _this.icon.innerHTML = "-";
                        // get content inner height
                        var contentInnerHeight = _this.filterValuesInner.clientHeight;
                        // if height is greater than 140px, set to 140px
                        if (contentInnerHeight > 200 && !_this.el.classList.contains("no-height-limit")) {
                            contentInnerHeight = 200;
                            _this.filterValues.classList.add("show-gradient");
                            _this.filterValues.style.overflowY = "auto";
                        } else {
                            _this.filterValues.classList.remove("show-gradient");
                            _this.filterValues.style.overflowY = "hidden";
                        }
                        // set content height
                        _this.filterValues.style.height = "".concat(contentInnerHeight, "px");
                    }
                });
            }
        }
    ]);
    return FilterDropdown;
}();

});

})();
//# sourceMappingURL=FilterDropdown.702c9ddc.js.map
